import React, { useEffect } from "react";
// components
import {

  TabsLayout,
  TabPanelLayout,
} from "../../components";
import Layout from "../../layout/Layout";

import { useLocation, } from "react-router-dom";

import {
  ApplicationManagementChr,
  MenuManagementChr,
  ApiManagementChr,
  RoleManagementChr,
  UserGroupsChr,

  AccessPermissionsChr,
  MenuAccessPermissionsChr,
  ChrUserOnboarding,
  ViewUserOnboarding

} from "../../pages"


// import UserAccess from "../user-access/UserAccess";
// import ProjectConfigLayout from "./project-config/ProjectConfigLayout";
// import RCConfigLayout from "./rc-config/RCConfigLayout";
// import QEConfigLayout from "./qe-config/QEConfigLayout";
// import EvalNextConfigConfigLayout from "./evalnext-config/EvalNextConfigLayout";
import { useSelector } from "react-redux";

// =========================================================================================================
const SetupLayout = React.memo((props) => {
  const [value, setValue] = React.useState(0);
  const { data: permissionsData } = useSelector(state => ({ ...state.permissions }));

  const { selectedData } = useSelector((state) => ({ ...state.authChr }))
  const location = useLocation()
  const evalNextPermission = React.useMemo(() => {
    return ["Organization.Setup.getSkillCategory", "Organization.Setup.getProficiencyLevel",
      "Organization.Setup.getCompetencyFramework", "Organization.Setup.getCompetencyFrameworkByAccount",
      "Organization.Setup.getCompetencyFrameworkByProject"
    ].some(item => permissionsData?.has(item));
  }, [permissionsData]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };



  const tabsName = location?.state?.l3Menu?.some((data) => data?.level3Menu?.l3MenuName === "App Services") ?
    [
      {
        name: "App Services",
        display: true
      },
      {
        name: "Roles",
      },
      {
        name: "Users",
      },
      {
        name: "User Details",
        display: Object.keys(selectedData).length > 0 && value === 3 ? true : false
      }

    ].filter(Boolean) :
    [

      {
        name: "Roles",
      },
      {
        name: "Users",
      },
      {
        name: "User Details",
        display: Object.keys(selectedData).length > 0 && (value === 2 || value === 3) ? true : false
      }

    ].filter(Boolean)





  const tabsData = location?.state?.l3Menu?.some((data) => data?.level3Menu?.l3MenuName === "App Services") ? [

    {
      name: "Menu Management",
      components: [{ component: <ApplicationManagementChr /> }],
    },
    {
      components: [{ component: <RoleManagementChr /> }],
    },

    {
      components: [{ component: <ChrUserOnboarding val={location?.state?.l3Menu?.some((data) => data?.level3Menu?.l3MenuName === "App Services") ? 3 : 2} setValue={setValue} /> }],
    },
    {
      components: [{ component: <ViewUserOnboarding val={location?.state?.l3Menu?.some((data) => data?.level3Menu?.l3MenuName === "App Services") ? 3 : 2} setValue={setValue} /> }],
    },


    // {
    //   components: [{ component: <AccessPermissionsChr /> }],
    // },
  ].filter(Boolean) : [


    {
      components: [{ component: <RoleManagementChr /> }],
    },

    {
      components: [{ component: <ChrUserOnboarding val={location?.state?.l3Menu?.some((data) => data?.level3Menu?.l3MenuName === "App Services") ? 3 : 2} setValue={setValue} /> }],
    },
    {
      components: [{ component: <ViewUserOnboarding val={2} setValue={setValue} /> }],
    },


    // {
    //   components: [{ component: <AccessPermissionsChr /> }],
    // },
  ].filter(Boolean)



  useEffect(() => {
    if (location?.state?.
      isNavigatePermission) {
      setValue(location?.state?.l3Menu?.some((data) => data?.level3Menu?.l3MenuName === "App Services") ? 1 : 0)
    }

  }, [])




  try {
    return (
      <Layout>
        <>

          <TabsLayout
            backgroundColor=""
            customWidth="13rem"
            value={value}
            handleChange={handleChange}
            tabNames={tabsName}
            matchingValue={[0, 1, 2, 3, 4]}
          />
          <TabPanelLayout value={value} index={0} tabsData={tabsData} />
        </>
      </Layout>
    );
  } catch (err) {
    // return <CommonErrorMessage />;
  }
});

export default SetupLayout;
